var _rect, _rect2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 0.399902,
    width: 59.1111,
    height: 43.5556,
    rx: 8,
    fill: "url(#paint0_linear_317_1873)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9.3999,
    width: 61.0714,
    height: 45,
    rx: 8,
    fill: "url(#paint1_linear_317_1873)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91668 23.2694C10.5275 23.2694 11.8334 21.9636 11.8334 20.3527C11.8334 18.7419 10.5275 17.436 8.91668 17.436C7.30584 17.436 6 18.7419 6 20.3527C6 21.9636 7.30584 23.2694 8.91668 23.2694Z",
    fill: "#F7CE46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5951 23.2694C19.206 23.2694 20.5118 21.9636 20.5118 20.3527C20.5118 18.7419 19.206 17.436 17.5951 17.436C15.9843 17.436 14.6785 18.7419 14.6785 20.3527C14.6785 21.9636 15.9843 23.2694 17.5951 23.2694Z",
    fill: "#F7CE46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8417 23.2694C27.4526 23.2694 28.7584 21.9636 28.7584 20.3527C28.7584 18.7419 27.4526 17.436 25.8417 17.436C24.2309 17.436 22.925 18.7419 22.925 20.3527C22.925 21.9636 24.2309 23.2694 25.8417 23.2694Z",
    fill: "#F7CE46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_1873",
    x1: 11,
    y1: 0.399902,
    x2: 70.1111,
    y2: 43.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7F4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DE5AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_317_1873",
    x1: 0,
    y1: 9.3999,
    x2: 61.0714,
    y2: 54.3999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E2FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.dc5e3341fc1b0814b54652eb0dd3c816.svg";
export { ForwardRef as ReactComponent };